<mat-card appearance="outlined">
  <mat-card-title>
    <span class="edit-screen-card-title"
          [translate]="'riskIndicators.title'">Risk indicators</span>
  </mat-card-title>
  <mat-card-content class="remove-mat-form-field-wrapper">
    <form [formGroup]="riskIndicatorsForm">
      <div layout="column">
        <div flex
             layout="row"
             layout-wrap
             layout-align="space-between center">


          <!-- Sanctions uncomment if needed -->
          <!-- <mat-form-field flex-gt-md="33"
                          flex-gt-sm="50"
                          flex="100"
                          floatLabel="always">
            <input matInput
                   type="text"
                   formControlName="sanctions" />
            <mat-label>{{ 'riskIndicators.sanctions' | translate }}</mat-label>
          </mat-form-field> -->

          <!-- Company Participation -->
          <mat-form-field flex-gt-md="50"
                          flex-gt-sm="70"
                          flex="100"
                          floatLabel="always">
            <input matInput
                   type="text"
                   formControlName="companyParticipation"
                   [class.risk-error]="regdataError" />
            <mat-label>{{ 'riskIndicators.companyParticipation' | translate }}</mat-label>
          </mat-form-field>

          <!-- Seizure -->
          <mat-form-field flex-gt-md="50"
                          flex-gt-sm="50"
                          flex="100"
                          floatLabel="always">
            <input matInput
                   type="text"
                   formControlName="seizure"
                   [class.risk-match]="seizureMatch === true && !regdataError"
                   [class.risk-nomatch]="seizureMatch === false && !regdataError"
                   [class.risk-error]="regdataError" />
            <mat-label>{{ 'riskIndicators.seizure' | translate }}</mat-label>
          </mat-form-field>

          <!-- NAP -->
          <mat-form-field flex-gt-md="50"
                          flex-gt-sm="50"
                          flex="100"
                          floatLabel="always">
            <input matInput
                   type="text"
                   formControlName="nap"
                   [class.risk-match]="napMatch === true && !regdataError"
                   [class.risk-nomatch]="napMatch === false && !regdataError"
                   [class.risk-error]="regdataError" />
            <mat-label>{{ 'riskIndicators.nap' | translate }}</mat-label>
          </mat-form-field>

          <!-- Phone Match -->
          <mat-form-field flex-gt-md="50"
                          flex-gt-sm="50"
                          flex="100"
                          floatLabel="always">
            <input matInput
                   type="text"
                   formControlName="phoneMatch"
                   [class.risk-error]="regdataError" />
            <mat-label>{{ 'riskIndicators.phoneMatch' | translate }}</mat-label>
          </mat-form-field>

          <!-- PEP -->
          <!-- PEP Input with Buttons inside -->
          <mat-form-field flex-gt-md="50"
                          flex-gt-sm="50"
                          flex="100"
                          floatLabel="always">
            <input matInput
                   type="text"
                   formControlName="pep"
                   [class.risk-match]="pepMatch === true && !pepError"
                   [class.risk-nomatch]="pepMatch === false && !pepError"
                   [class.risk-error]="pepError" />
            <mat-label>{{ 'riskIndicators.pep' | translate }}</mat-label>

            <div matSuffix
                 layout="row"
                 layout-align="start center">
              <button mat-stroked-button
                      color="primary"
                      type="button"
                      style="margin-left: 8px; min-width: auto; transform: scale(0.9);"
                      (click)="onInfoClick()">
                {{ (showPepReport ? 'riskIndicators.hideInfo' : 'riskIndicators.info') | translate }}
              </button>
              <button mat-stroked-button
                      color="primary"
                      type="button"
                      style="margin-left: 4px; min-width: auto; transform: scale(0.9);"
                      (click)="onShowRawJsonClick()">
                {{ 'riskIndicators.showRawJson' | translate }}
              </button>
            </div>
          </mat-form-field>

          <!-- PEP Report Expandable Table -->
          <div *ngIf="showPepReport"
               flex="100"
               class="pep-report-container">
            <div *ngIf="isLoadingPepReport"
                 class="pep-report-loading">
              <mat-spinner diameter="40"></mat-spinner>
            </div>

            <div *ngIf="!isLoadingPepReport && pepReportError"
                 class="pep-report-error">
              {{ 'riskIndicators.apisUnavailable' | translate }}
            </div>

            <div *ngIf="!isLoadingPepReport && !pepReportError && pepReportData.length === 0"
                 class="pep-report-empty">
              {{ 'riskIndicators.noRecords' | translate }}
            </div>

            <table *ngIf="!isLoadingPepReport && !pepReportError && pepReportData.length > 0"
                   mat-table
                   [dataSource]="pepReportData"
                   class="pep-report-table">

              <!-- Position Column -->
              <ng-container matColumnDef="position">
                <th mat-header-cell
                    *matHeaderCellDef>{{ 'riskIndicators.position' | translate }}</th>
                <td mat-cell
                    *matCellDef="let record">{{ record.xmlPosition || '-' }}</td>
              </ng-container>

              <!-- Institution Column -->
              <ng-container matColumnDef="institution">
                <th mat-header-cell
                    *matHeaderCellDef>{{ 'riskIndicators.institution' | translate }}</th>
                <td mat-cell
                    *matCellDef="let record">{{ record.xmlWork || '-' }}</td>
              </ng-container>

              <!-- End Date Column -->
              <ng-container matColumnDef="endDate">
                <th mat-header-cell
                    *matHeaderCellDef>{{ 'riskIndicators.endDate' | translate }}</th>
                <td mat-cell
                    *matCellDef="let record">{{ record.toDate ? (record.toDate | date:'yyyy-MM-dd') : '-' }}</td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell
                    *matHeaderCellDef>{{ 'riskIndicators.status' | translate }}</th>
                <td mat-cell
                    *matCellDef="let record">{{ calculatePepStatus(record.toDate) }}</td>
              </ng-container>

              <tr mat-header-row
                  *matHeaderRowDef="['position', 'institution', 'endDate', 'status']"></tr>
              <tr mat-row
                  *matRowDef="let row; columns: ['position', 'institution', 'endDate', 'status'];"></tr>
            </table>
          </div>


        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
